export default __webpack_public_path__ + "static/media/WaterjetCutterImg.29ec5451.jpg";